import GetDataItemByIdRequestModelBase from '../_generated/modelBases/get-data-item-by-id-request-model-base';

export default class GetDataItemByIdRequestModel extends GetDataItemByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
